import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchDataNotFoundDrawerProps as Props } from './types';

export const SearchDataNotFoundDrawer = memo(
  ({ className, title, icon }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('SearchDataNotFoundDrawer', className)}
        sx={SX.root}
      >
        <Stack sx={SX.emptyIconWrapper}>
          <Icon name={icon} sxx={SX.emptyIcon} size={36} />
        </Stack>

        <Stack sx={SX.notFoundTitleWrapper}>
          <Typography sx={SX.title}>{title}</Typography>
        </Stack>
      </Styled.Wrapper>
    );
  }
);

SearchDataNotFoundDrawer.displayName = 'SearchDataNotFoundDrawer';
